/** @format */
/**
 * Returns a srcSet based on an image URL including specific contentful API
 * transformations such as format and width
 *
 * @param {String} url The image URL
 * @param {String} format The image format
 * @param {number[]} widths an array of image widths to return
 * @param {number} ratio Optional ratio value for image transforms
 * @return {String} a srcSet string
 */

export function contentfulSrcSet(
    url: string,
    format?: string,
    widths: number[] = [400, 690, 1200],
    ratio?: number
): string {
    return widths
        .map((width) => {
            const height = ratio && Math.floor(width * ratio);

            return `${url}?fit=fill&w=${width}${format ? `&fm=${format}` : ''}${
                height ? `&h=${height}` : ''
            } ${width}w`;
        })
        .join(',');
}
